import React from "react";
import { IBaseDisplayBehaviour } from "./IBaseDisplayBehaviour";
import { getDisplayBehaviour } from "./displayFactory";

const displayBehaviourContext = React.createContext<{ behaviour: IBaseDisplayBehaviour }>({
  behaviour: getDisplayBehaviour()
});

function DisplayBehaviourProvider(props: { children: React.ReactNode }) {
  const value = React.useMemo(() => {
    return { behaviour: getDisplayBehaviour() };
  }, []);

  return <displayBehaviourContext.Provider value={value} {...props} />;
}

function useDisplayBehaviour() {
  const context = React.useContext(displayBehaviourContext);
  if (context === undefined) {
    throw new Error(`useDisplayBehaviour must be used within a DisplayBehaviourProvider`);
  }
  return context;
}

export { useDisplayBehaviour, DisplayBehaviourProvider };
